import React, { useEffect, useState } from "react";
import API from "../../Service/Baseservice";
import { useNavigate } from "react-router-dom";
import Loading from "../../../Loading/loading";
import Search from "../../../Assets/img/search.png";
import { useLocation } from "react-router-dom";
const PaymentRequest = () => {
    const [candidate, setCandidate] = useState([]);
    const [loading, setLoading] = useState(true);
    const [languageId, setLanguageId] = useState(1);
    const [search, setSearch] = useState("");
    const navigate = useNavigate();
   const location = useLocation();
    const [pageNumber, setPage] = useState(1);
    const rowsPerPage = 10;
    const [totalPages, setTotalPages] = useState(1);
    const customerFieldMap = {
        1: { 
            name: "full_name",
            email: "email",
            mobile: "mobile_number"
        },
        2: {
            name: "nom_et_prénom",
            email: "e_-mail",
            mobile: "numéro_de_portable"
        }
    };

    const fetchConsultationList = () => {
        setLoading(true);

        let req  = {
            pageNumber: pageNumber,
            rowsPerPage:rowsPerPage,
            language_id: languageId,
            search
        }

        API.post("paymentRequestList/condition",req ).then((response) => {
                const resData = response.data?.data;
                const list = resData?.data || [];
                const totalRecords = resData?.totalRecords || 0;

                setTotalPages(Math.ceil(totalRecords / rowsPerPage));

                const formatted = list.map((item) => {
                    const map = customerFieldMap[languageId];

                    return {
                        id: item.consultation_booking_id,
                        firstName: item.customer?.[map.name] || "--",
                        email: item.customer?.[map.email] || "--",
                        mobile: item.customer?.[map.mobile] || "--",
                        heading: item.heading || "--",
                        consultationType: item.consultation_type_name || "--",
                        bookingDate: item.booking_date || "--",
                        start_time: item.start_time || "--",
                        end_time: item.end_time || "--",
                        
                    };
                });


                setCandidate(formatted);
            })
            .catch((err) => {
                console.error("Error fetching consultation list:", err);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchConsultationList();
    }, [pageNumber, languageId]);

    const handleSearch = () => {
        localStorage.removeItem("candidatePage");
        setPage(1);
        fetchConsultationList();
    };
   

   

    useEffect(() => {
        if (location.state?.pageNumber) {
            setPage(location.state.pageNumber);

          
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);
    return (
        <div className="admin-container">
            <div className="news-header">
                <h2 className="news-title">Payment Request</h2>
            </div>



            <div className="filter-header">
                <div className="filter-left">
                    <div className="category-filter-block1">
                        <label>Search</label>
                        <div className="category-input-container1">
                            <input
                                placeholder="Search..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="category-input-field1"
                            />
                        </div>
                    </div>

                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                value={languageId}
                                onChange={(e) => {
                                    setLanguageId(Number(e.target.value));
                                    setPage(1);
                                }}
                                className="input-field"
                            >
                                <option value="1">English</option>
                                <option value="2">Français</option>
                            </select>
                        </div>
                    </div>

                    <div className="filter-btn-wrapper mt-3" onClick={handleSearch}>
                        <img src={Search} alt="Search" className="icon-btnf" />
                    </div>
                </div>
               
            </div>


          
            <div className="admin-table-wrapper">
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Mobile Number</th>
                                    <th>Heading</th>
                                    <th>Consultation Type</th>
                                    <th>Booking Date</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                   
                                  
                                </tr>
                            </thead>

                            <tbody>
                                {candidate.length > 0 ? (
                                    candidate.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.firstName}</td>
                                            <td>{item.email}</td>
                                            <td>{item.mobile}</td>
                                            <td>{item.heading}</td>
                                            <td>{item.consultationType}</td>
                                            <td>{item.bookingDate}</td>
                                            <td>{item.start_time}</td>
                                            <td>{item.end_time}</td>
                                           

                                          

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center" }}>
                                            No Data.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                     
                        {totalPages > 1 && (
                            <div className="pagination-container">
                                <button
                                    className="pagination-btn"
                                    onClick={() => setPage(pageNumber - 1)}
                                    disabled={pageNumber === 1}
                                >
                                    &lt;
                                </button>

                                {[...Array(totalPages)].map((_, i) => (
                                    <button
                                        key={i + 1}
                                        className={`pagination-btn ${pageNumber === i + 1 ? "active" : ""}`}
                                        onClick={() => setPage(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                ))}

                                <button
                                    className="pagination-btn"
                                    onClick={() => setPage(pageNumber + 1)}
                                    disabled={pageNumber === totalPages}
                                >
                                    &gt;
                                </button>
                            </div>
                        )}
                      
                     

                    </>
                )}
            </div>
        </div>
    );
};

export default  PaymentRequest
